<div class="summary-container">
	<div class="summary" [matBadge]="selectedBoxesCount" matBadgePosition="after" matBadgeOverlap="false"><span class="label">Nb de bannettes selectionnées</span></div>
	<div class="summary" [matBadge]="displayedFoldersCount | avmFileCounter" matBadgePosition="after" matBadgeOverlap="false">
		<span class="label">Nb de dossiers affichés</span>
	</div>
</div>
